import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/sl.ts
var add = "Dodaj";
var remove = "Odstrani";
var removeAll = "Odstrani vse";
var incomplete = "Nekatera polja niso pravilno izpolnjena.";
var submit = "Pošlji";
var noFiles = "Nobena datoteka ni izbrana";
var moveUp = "Premakni se navzgor";
var moveDown = "Premakni se navzdol";
var isLoading = "Nalaganje...";
var loadMore = "Naloži več";
var next = "Naslednji";
var prev = "Prejšnji";
var addAllValues = "Dodajte vse vrednosti";
var addSelectedValues = "Dodajanje izbranih vrednosti";
var removeAllValues = "Odstranite vse vrednosti";
var removeSelectedValues = "Odstrani izbrane vrednosti";
var chooseDate = "Izberite datum";
var changeDate = "Spremeni datum";
var close = "Zapri";
var open = "Odpri";
var accepted = function({
  name
}) {
  return `Prosimo popravite ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti po ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti v prihodnosti.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} lahko vsebuje samo znake abecede.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} lahko vsebuje samo črke in številke.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} lahko vsebuje samo črke in presledke.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} mora vsebovati abecedne znake.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} mora vsebovati črke ali številke.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mora vsebovati črke ali presledke.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} mora vsebovati simbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} mora vsebovati velike črke.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} mora vsebovati male črke.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} mora vsebovati številke.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} mora biti simbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} lahko vsebuje le velike črke.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} lahko vsebuje le male črke.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti pred ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti v preteklosti.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `To polje je narobe nastavljeno in ne mora biti izpolnjeno.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} mora biti med ${a} in ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} se ne ujema.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ni pravilen datum, prosimo uporabite format ${args[0]}`;
  }
  return "To polje je narobe nastavljeno in ne mora biti izpolnjeno.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} mora biti med ${date(args[0])} in ${date(args[1])}`;
};
var email = "Vnesite veljaven e-poštni naslov.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} se mora kočati z ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} ni dovoljena vrednost.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} mora vsebovati vsaj en znak.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} mora vsebovati največ ${max2} znakov.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} mora biti dolg ${max2} znakov.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} mora vsebovati vsaj ${min2} znakov.`;
  }
  return `${sentence(name)} mora vsebovati med ${min2} in ${max2} znakov.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} ni dovoljena vrednost.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Največ je ${args[0]} ${name}.`;
  }
  return `${sentence(name)} je lahko največ ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nobena vrsta datoteke ni dovoljena.";
  }
  return `${sentence(name)} mora biti tipa: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Najmanj ${args[0]} ${name} je dovoljenih.`;
  }
  return `${sentence(name)} mora biti vsaj ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ni dovoljen(a/o) ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} mora biti številka.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ali ")} zahtevan je.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} je zahtevan(o/a).`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} se mora začeti z ${list(args)}.`;
};
var url = function() {
  return `Vnesite veljaven URL.`;
};
var invalidDate = "Izbrani datum je neveljaven.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var sl_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, sl_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=sl.mjs.map